// extracted by mini-css-extract-plugin
export default {"root":"AverageReviewRating_root__81gEf"};